import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ModuleConfig } from '../utility/module.js';

var defaultOptions = {
  environment: "default",
  release: "1.0",
  debug: false,
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  stateTransformer: function stateTransformer(state) {
    return state;
  }
};
var config = new ModuleConfig(defaultOptions);
var loggers = {};
/**
 * Gets current configuration options for the logging module
 * @returns {object} Logging module options
 */

var getLoggingModuleOptions = function getLoggingModuleOptions() {
  return config.getAll();
};
/**
 * Configures options for the logging module
 * @param {object} options Options to set
 * @param {string} options.environment Environment name to tag tracking events with
 * @param {string} options.release Release version to tag tracking events with
 * @param {boolean} options.debug Enables debug console log messages when tracking events occur, default false
 * @param {function} options.actionTransformer Transform function to optimise Redux action data saved against tracking events
 * @param {function} options.stateTransformer Transform function to optimise Redux state data saved against tracking events
 */


var setLoggingModuleOptions = function setLoggingModuleOptions(options) {
  return config.setAll(options);
};
/**
 * Alias for getLoggingModuleOptions
 */


var getLoggingOptions = function getLoggingOptions() {
  return getLoggingModuleOptions();
};
/**
 * Alias for setLoggingModuleOptions
 */


var setLoggingOptions = function setLoggingOptions(options) {
  return setLoggingModuleOptions(options);
}; // integration functions


var loggerExists = function loggerExists(type) {
  return !!loggers[type];
};

var addLogger = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(createFunc) {
    var logger;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createFunc();

          case 2:
            logger = _context.sent;

            if (!(!logger || loggerExists(logger.type))) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            if (logger.initialize) {
              logger.initialize();
            }

            loggers[logger.type] = logger;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addLogger(_x) {
    return _ref.apply(this, arguments);
  };
}();

var processLoggers = function processLoggers(loggerFunc) {
  Object.keys(loggers).forEach(function (key) {
    return loggerFunc(loggers[key]);
  });
};
/**
 * Configures and enables a custom logging integration
 * @param {object} logger Logger configuration
 * @param {string} logger.type Unique type for the logger
 * @param {function} logger.initialize Optional, initialization function
 * @param {function} logger.getMiddleware Optional, allows the logger to use its own Redux middleware
 * @param {function} logger.logNavigation Optional, callback when a navigation event is triggered
 * @param {function} logger.logError Optional, callback when an error event is triggered
 * @param {function} logger.setUserIdentity Optional, callback when the current user has changed
 * @param {function} logger.clearUserIdentity Optional, callback when there is no longer a current user
 */


var enableCustomLogger = function enableCustomLogger(logger) {
  return addLogger(function () {
    return Promise.resolve(logger);
  });
};

export { addLogger, enableCustomLogger, getLoggingModuleOptions, getLoggingOptions, loggerExists, processLoggers, setLoggingModuleOptions, setLoggingOptions };
